<div id="topStepper" class="static w-full max-w-screen-xl mx-auto md:py-5 md:px-15 sm:p-0 bg-card">

    <div class="flex flex-col max-w-screen-xl mx-auto justify-center items-center mt-4">

        <div class="flex flex-col min-h-200 h-auto w-full">

            <formly-field [field]="baseStep"></formly-field>

            <mat-accordion>
                <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title> Vedi istanza completa >> </mat-panel-title>
                        <mat-panel-description> {{model.tipo.descrizione}}</mat-panel-description>
                    </mat-expansion-panel-header>


                    <div *ngFor="let step of steps; let index = index; let last = last">
                        <formly-field [field]="step"></formly-field>
                    </div>

                    <div class="flex flex-row mt-8 justify-between">

                        <button mat-flat-button class="px-4 mr-2" [color]="'primary'" [routerLink]="['/area-utente']">
                            <span>Chiudi</span>
                        </button>

                        <button *ngIf="user.is_superuser" mat-flat-button matStepperPrevious class="px-4 mr-2"
                            [color]="'primary'" type="button" (click)="tornaCompilazione()"
                            aria-labelledby="Torna in compilazione">
                            Torna in compilazione (ADMIN)
                        </button>

                        <button *ngIf="user.is_superuser && model.stato_id!='presentata'" mat-flat-button class="px-4 mr-2" [color]="'primary'"
                            (click)="inoltraIstanza()" type="button" aria-labelledby="Inoltra istanza">
                            Inoltra l'istanza
                        </button>

                    </div>

                </mat-expansion-panel>
            </mat-accordion>

        </div>
    </div>

</div>
